import { Component, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { Store } from '@ngrx/store';
import * as selectors from '../../store/selectors/museum-collections.selector';
import { HeaderComponent } from 'src/app/standalone/components/header/header.component';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { StripEmbedPipe, getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';

import { BreadcrumbsComponent } from '../../../standalone/components/breadcrumbs/breadcrumbs.component';
import { DetailHeaderGalleryComponent } from 'src/app/standalone/components/detail-header-gallery/detail-header-gallery.component';
import { CollectionCardComponent } from '../../components';
import { Button, LinkComponent } from '@teamfoster/sdk/button';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { IconComponent } from '@teamfoster/sdk/icon';
import { DynamicHooksModule } from 'ngx-dynamic-hooks';

@Component({
    selector: 'app-museum-collection',
    templateUrl: './museum-collection.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./museum-collection.component.scss'],
    imports: [
        ResizeHtmlImagesPipe,
        StripEmbedPipe,
        DetailHeaderGalleryComponent,
        BreadcrumbsComponent,
        CollectionCardComponent,
        LinkComponent,
        FromDictionaryPipe,
        IconComponent,
        DynamicHooksModule,
    ]
})
export class MuseumCollectionComponent {
  private store = inject(Store);
  collection$ = this.store.selectSignal(selectors.getSelectedMuseumCollection);
  otherCollections$ = this.store.selectSignal(selectors.getOtherMuseumCollections);
  cookiePreferences = this.store.selectSignal(getCookiePreferences);

  breadcrumbs: Button[] = [{ text: 'Museum', routerLink: ['/museum'], fragment: 'ontdek-de-coda-collectie', url: '' }];
}
